module.exports = __webpack_public_path__ + "d45bdbc.ttf";